import { inject, Injectable } from '@angular/core';
import { StripeService } from '@df/module-stripe/stripe.service';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { Platform } from '@angular/cdk/platform';
import { PwaNativeBridgeService } from '../pwa/pwa-native-bridge.service';

/**
 * Local decorator for StripeService
 * Overrides Apple Pay support check to consider standalone app mode
 */
@Injectable({ providedIn: 'root' })
export class LocalStripeService extends StripeService {
    private pwaIntegrationService = inject(PwaIntegrationService);
    private platform = inject(Platform);

    /**
     * Override Apple Pay support check to include standalone app detection
     * In standalone mode, Apple Pay should be supported if Apple Pay is available
     * @returns {boolean}
     */
    override isExpressCheckoutApplePaySupported(): boolean {
        if (this.pwaIntegrationService?.isStandalone && this.platform.IOS) {
            return this.applePayService.isAvailable;
        }

        // Otherwise, use the original logic
        return super.isExpressCheckoutApplePaySupported();
    }
}
